import { type HistoryMessage, isChatAction, isChatMessage } from './type';

/**
 * Keys of the rendered messages.
 *
 * A message sent from here has no saved id yet. When the id arrives the
 * message keeps the key it already has, so its element stays in the list and
 * the reader stays where they are.
 */
export class MessageKeys {
  /** Saved id to the key the message had before it was saved. */
  private readonly _sentKeys = new Map<string, string>();

  keyOf(item: HistoryMessage, index: number): string | number {
    if (isChatMessage(item)) {
      if (!item.id) return unsavedKey(item);
      return this._sentKeys.get(item.id) ?? item.id;
    }
    if (isChatAction(item)) {
      return `${item.action}:${index}`;
    }
    return index;
  }

  /** The list changed: a message that just got its saved id keeps its key. */
  adopt(
    previous: readonly HistoryMessage[],
    next: readonly HistoryMessage[]
  ): void {
    if (previous.length !== next.length) return;
    next.forEach((item, index) => {
      const before = previous[index];
      if (!isChatMessage(item) || !item.id) return;
      if (!isChatMessage(before) || before.id) return;
      if (before.role !== item.role) return;
      this._sentKeys.set(item.id, unsavedKey(before));
    });
  }
}

function unsavedKey(item: { role: string; createdAt: string }) {
  return `sent:${item.role}:${item.createdAt}`;
}
